import script from "./courseList.vue?vue&type=script&setup=true&lang=js"
export * from "./courseList.vue?vue&type=script&setup=true&lang=js"

import "./courseList.vue?vue&type=style&index=0&id=42e8885c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42e8885c"]])

export default __exports__